// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ApiExplorer: MarkdocTagRegistration = {
  tag: 'api-explorer',
  component: 'ApiExplorer',
};
